import React from "react";
import "./css/Terms.css";

const Terms = () => {
  return (
    <div className="terms-page">
      <h1>Terms of Service</h1>
      <p>Last updated: July 2025</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By using this website or app, you agree to our terms and conditions. If you do not agree, please discontinue use immediately.
        </p>
      </section>

      <section>
        <h2>2. Use of Services</h2>
        <p>
          You may not misuse our services, violate laws, or harm the platform. We reserve the right to suspend users who break our terms.
        </p>
      </section>

      <section>
        <h2>3. Intellectual Property</h2>
        <p>
          All trademarks, content, and code belong to Vyral Media Group unless stated otherwise. You may not copy or reuse without permission.
        </p>
      </section>

      <section>
        <h2>4. Limitation of Liability</h2>
        <p>
          We are not liable for indirect damages resulting from use or inability to use our platform.
        </p>
      </section>

      <section>
        <h2>5. Changes</h2>
        <p>
          We may update these terms at any time. Continued use implies acceptance of the new terms.
        </p>
      </section>
    </div>
  );
};

export default Terms;